import React, { ReactNode, useState } from 'react';
import { WixPatternsEssentialsOverrides } from '@wix/bex-core';
import { useEssentials } from '@wix/fe-essentials/react';
import { CairoProvider } from '../providers';
import { buildCairoEssentials } from './buildCairoEssentials';

export interface WixPatternsProviderEssentialsProps {
  value?: Partial<WixPatternsEssentialsOverrides>;
  children?: ReactNode;
  localCache?: boolean;
}

export function WixPatternsProviderEssentials({
  value,
  children,
  localCache,
}: WixPatternsProviderEssentialsProps) {
  const essentials = useEssentials();

  const [cairoEssentials] = useState(() =>
    buildCairoEssentials(essentials, {
      overrides: value,
    }),
  );

  return (
    <CairoProvider value={cairoEssentials} localCache={localCache}>
      {children}
    </CairoProvider>
  );
}
